export const WORKFLOWS_APP_ACCESS = 'workflows-app-access';
export const FORMAT_DATA_ACCESS = 'workflows-format-data-access';